/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Clear_Timecodes_TitleInputs */



/**
* | output |
* | --- |
* | "Are you sure?" |
*
* @param {Shortcut_Keys_Clear_Timecodes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_clear_timecodes_title = /** @type {((inputs?: Shortcut_Keys_Clear_Timecodes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Clear_Timecodes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Etes-vous sur ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bist du sicher?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sei sicuro?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы уверены?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Está seguro?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("你确定吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("本気ですか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आपको यकीन है?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tem certeza?")
	return /** @type {LocalizedString} */ ("Are you sure?")
});